import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/** Font-size utilities from `typography.css` — keep in sync with @theme and @utility tokens. */
const MM_FONT_SIZE_CLASSES = [
	// Scale tokens (`text-mm-*`)
	"text-mm-2xs",
	"text-mm-xs",
	"text-mm-sm",
	"text-mm-caption",
	"text-mm-base",
	"text-mm-body-sm",
	"text-mm-body",
	"text-mm-body-lg",
	"text-mm-md",
	"text-mm-lg",
	"text-mm-xl",
	"text-mm-2xl",
	"text-mm-page",
	"text-mm-display-sm",
	"text-mm-display",
	"text-mm-display-lg",
	"text-mm-badge",
	// Composed utilities (`type-*`)
	"type-page-title",
	"type-page-sub",
	"type-table-head",
	"type-table-cell",
	"type-table-desc",
	"type-table-status-sub",
	"type-table-status-paused",
	"type-table-empty",
	"type-badge",
	"type-seg",
	"type-btn",
	"type-nav-group",
	"type-nav-link",
	"type-nav-sub",
	"type-brand",
	"type-brand-sub",
] as const

const customTwMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			"font-size": [...MM_FONT_SIZE_CLASSES],
		},
	},
})

export function cn(...inputs: ClassValue[]) {
	return customTwMerge(clsx(inputs))
}
